export default __webpack_public_path__ + "static/media/Illustration-Magic.57ac7aac.svg";